export default __webpack_public_path__ + "media/zurb/img/case-study-iqtell/iqtell-hero-screenshot-919f3e0158d2d59794d0968554d37421.png";